/* eslint-disable max-depth */
import React, { useState, useEffect, useCallback } from 'react';
import moment, { Moment } from 'moment';
import {
    Row,
    Col,
    Tabs,
    Slider,
    DatePicker,
    Button,
    Tree,
    Modal,
    Spin,
    Input
} from 'antd';
import {
    soilSearchGetRadiusSetting,
    weatherCheckQueryNameIsExist,
    weatherGetQuery,
    weatherGetWeatherStationDetail,
    weatherSaveQuery
} from '@/util/Request';

import {
    CloseSvg,
    SoilSearchClearIcon,
    SoilProfileWarningAlertIcon,
    SoilProfileCloseIcon,
    SoilSearchStar,
    SoilProfileDropDownIcon,
    SoilProfileExpandIcon,
    WeatherLeftMenuBar,
    SoilCloseIcon,
} from '@/resource/IconComponentSets';
import './index.less';
import IF from '@/components/IF';
import WeatherStationQueryDetails from '@/components/WeatherStationQueryDetails';
import SoilInputSelectComponent from '@/components/SoilInputSelectComponent';
import { ISoilProfilePlaceGeoNames, IWeatherSaveQueryReqModel, IWeatherStationReqModel, IWeatherStationResModel } from '@/util/Request/requestType';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@reduxjs/toolkit';
import { updateSearchRadiusSetting } from '@/redux/reducer/soilSerach';
import SoilLatLonInputSelectComponent from '@/page/Soil/soil-list/Component/SoilLatLonInputSelectComponent';
import SoilSupplierComponent from './Component/SoilSupplierComponent';
import SoilSupplierPropertiesComponent, { ISelectedProps } from './Component/SoilSupplierPropertiesComponent';
import {
    updateChartData,
    updateDeselectedStations,
    updateDrawOnMapData,
    updatePolyFuncEnableState,
    updateRequestOptions,
    updateSavedQueryId,
    updateSelectedStations,
    updateStationReqDate,
    updateTreeData,
    updateUnderChartState
} from '@/redux/reducer/weatherStation';
import { updateSuccessMessage, updateWarningMessage } from '@/redux/reducer/common';
import { useLocation, useNavigate } from 'react-router-dom';
import SoilSupplierStationPropertiesComponent from './Component/SoilSupplierStationPropertiesComponent';
import localforage from 'localforage';

const { confirm } = Modal;

enum TabsEnum {
    Name = 'Name',
    Coordinates = 'Coordinates',
    AdministrativeAreas = 'AdministrativeAreas',
    DrawOnMap = 'DrawOnMap',
    Station = 'Station'
}

enum TitleEnum {
    SelectLoaction = 'Select weather data by',
    Name = 'Name',
    Locatons = 'Locations',
    AdminArea = 'Administer area',
    DrawOnMap = 'Draw on map',
    Station = 'Station'
}

const { RangePicker } = DatePicker;

let isShowWarning = false;
export default function WeatherQuery() {
    // locations
    const [selectedLocations, setSelectedLocations] = useState<ISoilProfilePlaceGeoNames[]>([]);
    const [noticeVisible, setNoticeVisible] = useState<boolean>(true);

    // coordinates
    const [selectedCoordinates, setSelectedCoordinates] = useState([]);
    const [latLonString, setLatLonString] = useState<string>('');

    // areas' tree
    // const [treeData, setTreeData] = useState([]);
    const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
    const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]);
    // adm request param
    const [checkedCityNodes, setCheckedCityNodes] = useState<{
        region: string
        country: string
        state: string
        cityname: string
        placename: string
        id?: string
        originKey?: string
    }[]>([]);

    // draw on map
    const [polygonReq, setPolygonReq] = useState<string>('');

    // date range
    const [dateValue, setDateValue] = useState<[Moment, Moment]>(null);

    // radius
    const [radiusValue, setRadiusValue] = useState<number>(10);

    // suppliers
    const [selectedSuppliersPoperties, setSelectedSuppliersPoperties] = useState<ISelectedProps[]>([]);

    const [selectedSupplierStationProperties, setSelectedSupplierStationProperties] = useState<ISelectedProps[]>([]);

    const [showSupplierMenu, setShowSupplierMenu] = useState(false);

    const [currentQueryId, setCurrentQueryId] = useState<number>(0);

    // selected tab: name, coordinates, areas, map
    const [currentTab, setCurrentTab] = useState<TabsEnum>(TabsEnum.Name);
    const [isFetching, setIsFetching] = useState(false);
    const [mapDataIsFetching, setMapDataIsFetching] = useState(false);

    // execute result
    const [nameMapRes, setNameMapRes] = useState<IWeatherStationResModel>();

    const [coordinateMapRes, setCoordinateMapRes] = useState<IWeatherStationResModel>();

    const [adminMapRes, setAdminMapRes] = useState<IWeatherStationResModel>();

    const [drawOnMapRes, setdrawOnMapRs] = useState<IWeatherStationResModel>();

    const [stationMapRes, setStationMapRes] = useState<IWeatherStationResModel>();

    // set menu expand
    const [leftMenuBarExpand, setLeftMenuBarExpand] = useState(true);

    const [inputQueryShow, setInputQueryShow] = useState(false);

    const [queryName, setQueryName] = useState('');

    const [queryIsFetching, setQueryIsFetching] = useState(false);

    // current first title
    const [firstTitle, setFirstTitle] = useState<TitleEnum>(TitleEnum.SelectLoaction);

    const [requestParam, setRequestParam] = useState<IWeatherStationReqModel>(null);

    // save query used
    const [nameQueryId, setNameQueryId] = useState(0);
    const [coordinateQueryId, setCoordinateQueryId] = useState(0);
    const [admiQueryId, setAdmiQueryId] = useState(0);
    const [drawQueryId, setDrawQueryId] = useState(0);
    const [stationQueryId, setStationQueryId] = useState(0);
    const [enterTag, setEnterTag] = useState(0);

    const dispatch = useDispatch();

    const location = useLocation();
    const navigate= useNavigate();


    const queryGuid = useSelector((state: RootState) => state.weatherStation.queryId);
    const treeData = useSelector((state: RootState) => state.weatherStation.treeData);
    const { maxValue } = useSelector((state: RootState) => state.soilSearchPageData.radiusSetting);
    const {
        drawReactModel,
        drawCircleMode,
        polyPoint,
        center,
        radius
    } = useSelector((state: RootState) => state.weatherStation);

    // SECTION: Effect area =====================================================================================
    useEffect(() => {
        if (maxValue) {
            requestForRadiusSeting();
        }

        // document.addEventListener('keydown', (e) => handleKeyDown(e));
        return () => {
            // document.removeEventListener('keydown', handleKeyDown);
            dispatch(updateUnderChartState(false));
        };
    }, []);

    useEffect(() => {
        if (currentTab === TabsEnum.AdministrativeAreas) {
            handlePolitcalArea();
        }
        setShowSupplierMenu(false);
    }, [currentTab]);

    useEffect(() => {
        const head = document.getElementsByTagName('head')[0];
        const googleAnalyticsCode = 'G-VVW84651X1';
        const googleAnalyticsFirstScript = document.createElement('script');
        googleAnalyticsFirstScript.async = true;
        googleAnalyticsFirstScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + googleAnalyticsCode;

        const googleAnalyticsSecondScript = document.createElement('script');
        googleAnalyticsSecondScript.innerHTML =
          '    window.dataLayer = window.dataLayer || [];\n' +
          '    function gtag(){dataLayer.push(arguments);}\n' +
          '    gtag(\'js\', new Date());\n' +
          '\n' +
          '    gtag(\'config\', \'' +
          googleAnalyticsCode +
          '\',{\n' +
          'cookie_flags:\'max-age=7200;secure;samesite-none\'' +
          '});';

        head.insertBefore(googleAnalyticsSecondScript, head.firstChild);
        head.insertBefore(googleAnalyticsFirstScript, head.firstChild);
    }, []);

    useEffect(() => {
        if (queryGuid && queryGuid.length > 0) {
            getTargetQuery(queryGuid);
        }
    }, [queryGuid]);

    useEffect(() => {
        if (enterTag > 0) {
            executeClicked();
        }
    }, [enterTag]);

    useEffect(() => {
        const locationArr = location.pathname.split('/');
        const queryGuid = locationArr[2];
        const pathname = locationArr[1];
        if (pathname === 'weatherQuery' && queryGuid) {
            dispatch(updateSavedQueryId(queryGuid));
            navigate('/weatherQuery');
        }
    }, [location]);

    useEffect(() => {
        if (!leftMenuBarExpand) {
            switch(currentTab) {
                case TabsEnum.Name: {
                    setFirstTitle(TitleEnum.Name);
                    break;
                }
                case TabsEnum.Coordinates: {
                    setFirstTitle(TitleEnum.Locatons);
                    break;
                }
                case TabsEnum.AdministrativeAreas: {
                    setFirstTitle(TitleEnum.AdminArea);
                    break;
                }
                case TabsEnum.DrawOnMap: {
                    setFirstTitle(TitleEnum.DrawOnMap);
                    break;
                }
            }
        } else {
            setFirstTitle(TitleEnum.SelectLoaction);
        }
    }, [currentTab, leftMenuBarExpand]);

    useEffect(() => {
        if (currentTab === TabsEnum.DrawOnMap) {
            dispatch(updatePolyFuncEnableState(true));
        } else {
            dispatch(updatePolyFuncEnableState(false));
        }
    }, [currentTab]);

    // if request param was changed reset the query id
    useEffect(() => {
        setNameQueryId(0);
        setCoordinateQueryId(0);
        setAdmiQueryId(0);
        setDrawQueryId(0);
    }, [selectedSuppliersPoperties]);

    useEffect(() => {
        setStationQueryId(0);
    }, [selectedSupplierStationProperties]);

    useEffect(() => {
        if (dateValue !== null) {
            setNameQueryId(0);
            setCoordinateQueryId(0);
            setAdmiQueryId(0);
            dispatch(updateStationReqDate({
                startDate: dateValue && dateValue[0].format('DD/MM/yyyy'),
                endDate: dateValue && dateValue[1].format('DD/MM/yyyy')
            }));
        }
    }, [dateValue]);

    useEffect(() => {
        setNameQueryId(0);
        setCoordinateQueryId(0);
    }, [radiusValue]);

    useEffect(() => {setNameQueryId(0);}, [selectedLocations]);
    useEffect(() => {setCoordinateQueryId(0);}, [latLonString]);
    useEffect(() => { setAdmiQueryId(0);}, [checkedCityNodes]);
    useEffect(() => {setDrawQueryId(0);}, [polygonReq]);


    // SECTION: function area =====================================================================================
    const saveQueryFunc = async () => {
        if (queryName.length > 0) {
            const options = getRequestOptions(true);
            if (!options) {
                return;
            }
            setQueryIsFetching(true);
            const requestParam: IWeatherSaveQueryReqModel = {
                queryId: 0,
                queryName,
                options
            };
            try {
                const isExist = await weatherCheckQueryNameIsExist(queryName);
                if (isExist) {
                    setQueryIsFetching(false);
                    return showWarningMessage('The query name is exist!');
                }
                const queryId = await weatherSaveQuery(requestParam);
                setCurrentQueryId(queryId);
                // reset the request param
                setQueryName('');
                // show success message
                dispatch(updateSuccessMessage('Save the query successfully!'));
                setQueryIsFetching(false);
                setInputQueryShow(false);
            } catch(err) {
                setQueryIsFetching(false);
                dispatch(updateWarningMessage('Save the query failed!'));
            }
        } else {
            showWarningMessage('Query name can\'t be null!');
        }
    };

    const showWarningMessage = (message: string) => {
        if (isShowWarning === true) return;
        isShowWarning = true;
        confirm({
            className: 'soil-profile-warning-div',
            title: 'Warning',
            content: message,
            onOk() {
                isShowWarning = false;
            },
            onCancel() {
                isShowWarning = false;
            },
        });
    };

    const getTargetQuery = async (queryGuid: string) => {
        try {
            const query = await weatherGetQuery(queryGuid);
            const geometryObj = JSON.parse(query.geometryLocation);
            dispatch(updateDrawOnMapData({
                ...geometryObj,
                fromQueryHistory: true,

            }));
            const hierarchies = [];
            const weatherProperties = query.hierarchiesDetails.map((item) => {
                const hierarchiy = {
                    supplier: item.supplier,
                    variable: item.variable,
                    frequency: `${item.frequency}_${item.aggregation}`,
                    hierarchy: 3
                };
                hierarchies.push(hierarchiy);
                let showSelected;
                if (item.station !== null) {
                    showSelected = `${item.supplier}/${item.station.stationID}/${item.variableName}/${item.level}/${item.frequency}/${item.aggregation}`;
                } else {
                    showSelected = `${item.supplier}/${item.variableName}/${item.level}/${item.frequency}/${item.aggregation}`;
                }
                return {
                    supplier: item.supplier,
                    variable: item.variable,
                    frequency: item.frequency,
                    selected: true,
                    id: `${item.supplier}-${item.variable}-${item.frequency}`,
                    showSelected,
                    variableName: item.variableName,
                    level: item.level,
                    aggregation: item.aggregation,
                    isActive: item.isActive,
                    hierarchyId: item.hierarchyId,
                    um: item.um,
                    station: item.station,
                };
            });

            const {
                coordinates = [],
                locations = [],
                politicalAreas = [],
                geometryText = '',
                tabName,
                radius,
                startDate,
                endDate
            } = query;

            if (tabName === 'Station') {
                console.log('weatherProperties:====', weatherProperties);

                setSelectedSupplierStationProperties(weatherProperties);
            } else {
                setSelectedSuppliersPoperties(weatherProperties);
            }
            try {
                switch (tabName) {
                    case 'Name': {
                        setCurrentTab(TabsEnum.Name);

                        const newLocations = locations.map(item => {
                            return {
                                name: item.name,
                                adminName1: '',
                                adminName2: '',
                                lat: parseFloat(item.latitude),
                                lng: parseFloat(item.longitude),
                            };
                        });
                        setSelectedLocations(newLocations);
                        break;
                    }
                    case 'Coordinates': {
                        setCurrentTab(TabsEnum.Coordinates);

                        const latLonStrings = coordinates.map((item) => `${item.longitude},${item.latitude}`);
                        setSelectedCoordinates(latLonStrings);
                        break;
                    }
                    case 'Draw on map': {
                        setCurrentTab(TabsEnum.DrawOnMap);
                        // dispatch()
                        setPolygonReq(geometryText);
                        break;
                    }
                    case 'Administrative areas': {
                        setCurrentTab(TabsEnum.AdministrativeAreas);

                        let localCheckedKeys = [];
                        const political = politicalAreas.map((item) => {
                            const checkedKey = `${item.region}${item.country && `&${item.country}`}${item.state && `&${item.state}`}${item.cityname && `&${item.cityname}`}`;
                            localCheckedKeys = [...localCheckedKeys, checkedKey];
                            return {
                                ...item,
                                id: `${item.region}&${item.country}&${item.state}&${item.cityname}`
                            };
                        });
                        setExpandedKeys(localCheckedKeys);
                        setCheckedKeys(localCheckedKeys);
                        setCheckedCityNodes(political);
                        break;
                    }
                    case 'Station': {
                        setCurrentTab(TabsEnum.Station);
                        break;
                    }
                }
                if (tabName !== 'Draw on map' && query.radius && tabName !== 'Administrative areas' && tabName !== 'Station') {
                    setRadiusValue(query.radius);
                }
                setDateValue([moment(query.startDate, 'DD/MM/yyyy'), moment(query.endDate, 'DD/MM/yyyy')]);
            } catch(err) {
                console.log('err:===', err);
            }


            const options: IWeatherStationReqModel = {
                tabName,
                locations: locations,
                coordinates,
                politicalAreas,
                geometryText,
                radius,
                startDate,
                endDate,
                hierarchies: hierarchies.filter(Boolean),
                hierarchiesDetails: weatherProperties
            };
            setMapDataIsFetching(true);
            setRequestParam(options);
            dispatch(updateRequestOptions(options));
            const dataRes = await weatherGetWeatherStationDetail(options);
            const res = dataRes.data;
            switch(tabName) {
                case 'Name': {
                    setNameMapRes(res);
                    break;
                }
                case 'Coordinates': {
                    setCoordinateMapRes(res);
                    break;
                }
                case 'Administrative areas': {

                    setAdminMapRes(res);
                    break;
                }
                case 'Draw on map': {

                    setdrawOnMapRs(res);
                    break;
                }
                case 'Station': {
                    setStationMapRes(res);
                    break;
                }
            }
            setMapDataIsFetching(false);
        } catch(err) {
            if (err.status === 504) {
                showWarningMessage('Request data exceeds the length limit, please reduce the query data!');
            } else {
                showWarningMessage('Not found any stations according to query options!');
            }

            switch(currentTab) {
                case TabsEnum.Name: {
                    setNameMapRes(null);
                    break;
                }
                case TabsEnum.Coordinates: {
                    setCoordinateMapRes(null);
                    break;
                }
                case TabsEnum.AdministrativeAreas: {
                    setAdminMapRes(null);
                    break;
                }
                case TabsEnum.DrawOnMap: {
                    setdrawOnMapRs(null);
                    break;
                }
                case TabsEnum.Station: {
                    setStationMapRes(null);
                    break;
                }
            }
            setMapDataIsFetching(false);
        }
    };

    const onSelect = (selectedKeys, event) => {
        const selectedKey = event.node.key;
        const newExpandKeys = [...expandedKeys];

        if (expandedKeys.includes(selectedKey)) {
            const index = newExpandKeys.indexOf(selectedKey);
            const removeKeyArr = newExpandKeys.splice(index, 1);
            const targetKey = removeKeyArr[0];
            setExpandedKeys(newExpandKeys);
            configMenu(targetKey, newExpandKeys);
        } else {
            newExpandKeys.push(selectedKey);
            setExpandedKeys(newExpandKeys);
            configMenu(selectedKey, newExpandKeys);
        }
    };

    const onCheck = (checked: {
        checked: string[];
        halfChecked: string[]
    }) => {
        const checkedKeys = checked.checked;
        setCheckedKeys(checkedKeys);

        const area: string[] = [];
        const country: string[] = [];
        const state: string[] = [];
        const cityname: string[] = [];

        for (const item of checkedKeys) {
            const splitArr = item.split('&');
            switch (splitArr.length) {
                case 1: {
                    area.push(item);
                    break;
                }
                case 2: {
                    country.push(item);
                    break;
                }
                case 3: {
                    state.push(item);
                    break;
                }
                case 4: {
                    cityname.push(item);
                    break;
                }
            }
        }

        const filterRegionArr = new Set<string>();
        checkedKeys.forEach((item) => {
            let include = false;
            for (const areaItem of area) {
                if ( item !== areaItem && item.includes(areaItem)) {
                    include = true;
                }
            }
            if (!include) {
                filterRegionArr.add(item);
            }
        });

        const filterCountryArr = new Set<string>();
        filterRegionArr.forEach((item) => {
            let include = false;
            for (const countryItem of country) {
                if ( item !== countryItem && item.includes(countryItem)) {
                    include = true;
                }
            }
            if (!include) {
                filterCountryArr.add(item);
            }
        });


        const filterStateArr = new Set<string>();
        filterCountryArr.forEach((item) => {
            let include = false;
            for (const stateItem of state) {
                if ( item !== stateItem && item.includes(stateItem)) {
                    include = true;
                }
            }
            if (!include) {
                filterStateArr.add(item);
            }
        });

        const filterCityNamrArr = new Set<string>();
        filterCountryArr.forEach((item) => {
            let include = false;
            for (const citynameItem of cityname) {
                if ( item !== citynameItem && item.includes(citynameItem)) {
                    include = true;
                }
            }
            if (!include) {
                filterCityNamrArr.add(item);
            }
        });


        const newCheckedNodes = [];
        for (const item of filterCityNamrArr) {
            const adminArea = {
                region: '',
                country: '',
                state: '',
                cityname: '',
                placename: '',
                originKey: ''
            };
            const splitArr = item.split('&');
            splitArr.forEach((admin, index) => {
                switch (index) {
                    case 0:
                        adminArea.region = admin;
                        break;
                    case 1:
                        adminArea.country = admin;
                        break;
                    case 2:
                        adminArea.state = admin;
                        break;
                    case 3:
                        adminArea.cityname = admin;
                }
            });
            newCheckedNodes.push(adminArea);
        }

        setCheckedCityNodes(newCheckedNodes);
    };

    const selectLastItemDate = useCallback((type) => {
        let _startDate: Date;
        let _endDate: Date;
        const _now = new Date();
        let millisecondsOfDay: number;
        let dayOfWeek: number;
        switch (type) {
            case 'year':
                _startDate = new Date(_now.getFullYear() - 1, 0, 1);
                _endDate = new Date(_now.getFullYear() - 1, 11, 31);
                break;
            case 'month':
                _startDate = new Date(_now.getFullYear(), _now.getMonth() - 1, 1);
                _endDate = new Date(_now.getFullYear(), _now.getMonth(), 0);
                break;
            case 'week':
                millisecondsOfDay = 24 * 60 * 60 * 1000;
                dayOfWeek = _now.getDay();
                if (dayOfWeek === 0) dayOfWeek = 7;
                _startDate = new Date(_now.getTime() + (1 - dayOfWeek - 7) * millisecondsOfDay);
                _endDate = new Date(_now.getTime() + (7 - dayOfWeek - 7) * millisecondsOfDay);
                break;
            default:
                break;
        }
        setDateValue([moment(_startDate, 'yyyy-MM-dd'), moment(_endDate, 'yyyy-MM-dd'),]);
    }, []);

    const handlePolitcalArea = async () => {
        try {
            //const areasString = localStorage.getItem('politicalAreaList');
            const areasString = await localforage.getItem<string>('politicalAreaList');
            const areas = JSON.parse(areasString);
            const areaObj: unknown = {};
            for (const areaItem of areas) {
                if (!areaObj[areaItem.region]) {
                    areaObj[areaItem.region] = {[areaItem.country]: { [areaItem.state]: [areaItem.cityname]}};
                } else {
                    if (!areaObj[areaItem.region][areaItem.country]) {
                        areaObj[areaItem.region][areaItem.country] = {
                            [areaItem.state]: [areaItem.cityname]
                        };
                    } else {
                        if (!areaObj[areaItem.region][areaItem.country][areaItem.state]) {
                            areaObj[areaItem.region][areaItem.country][areaItem.state] = [areaItem.cityname];
                        } else {
                            areaObj[areaItem.region][areaItem.country][areaItem.state].push(areaItem.cityname);
                        }
                    }
                }
            }

            const regionArr = Object.keys(areaObj);
            const constructFirstArea = [];
            for (const region of regionArr) {
                const countries = Object.keys(areaObj[region]);
                const constructSecondArea = [];
                for (const country of countries) {
                    const states = Object.keys(areaObj[region][country]);
                    const constructThirdArea = [];
                    for (const state of states) {
                        const cityNames = areaObj[region][country][state];
                        const cityNodes = cityNames.map((cityname) => {
                            return {
                                title: cityname,
                                key: `${region}&${country}&${state}&${cityname}`,
                                icon: null,
                                children: [],
                                area_IfHasChildLevel: false
                            };
                        });
                        constructThirdArea.push({
                            title: state,
                            key: `${region}&${country}&${state}`,
                            icon: <SoilProfileDropDownIcon />,
                            children: cityNodes,
                            area_IfHasChildLevel: true
                        });
                    }
                    constructSecondArea.push({
                        title: country,
                        key: `${region}&${country}`,
                        icon: <SoilProfileDropDownIcon />,
                        children: constructThirdArea,
                        area_IfHasChildLevel: true
                    });
                }
                constructFirstArea.push({
                    title: region,
                    key: region,
                    icon: <SoilProfileDropDownIcon />,
                    children: constructSecondArea,
                    area_IfHasChildLevel: true
                });
            }
            dispatch(updateTreeData(constructFirstArea));
        } catch(err) {
            setIsFetching(false);
        }
    };

    const configMenu = (areaId, localExpandKeys) => {
        const keyArr = areaId.split('&');
        for (const state of treeData) {
            const stateKey = keyArr[0];
            if (stateKey && stateKey === state.key) {
                const stateItem = state;
                // if next children was null, define current children to current item
                if (!keyArr[1]) {
                    if (stateItem.area_IfHasChildLevel) {
                        const include = localExpandKeys.includes(keyArr[0]);
                        include ? stateItem.icon = <SoilProfileExpandIcon /> : stateItem.icon = <SoilProfileDropDownIcon />;
                    }
                    break;
                }
                const provinceKey = `${keyArr[0]}&${keyArr[1]}`;
                for (const provinceItem of stateItem.children) {
                    if (provinceItem.key === provinceKey) {
                        const targetProvinceItem = provinceItem;
                        if (!keyArr[2]) {
                            if (provinceItem.area_IfHasChildLevel) {
                                const include = localExpandKeys.includes(provinceKey);
                                include ? targetProvinceItem.icon = <SoilProfileExpandIcon /> : targetProvinceItem.icon = <SoilProfileDropDownIcon />;
                            }
                            break;
                        }
                        const cityKey = `${keyArr[0]}&${keyArr[1]}&${keyArr[2]}`;
                        for (const cityItem of targetProvinceItem.children) {
                            if (cityItem.key === cityKey) {
                                const targetCityItem = cityItem;
                                if (!keyArr[3]) {
                                    if (targetCityItem.area_IfHasChildLevel) {
                                        const include = localExpandKeys.includes(cityKey);
                                        include ? targetCityItem.icon = <SoilProfileExpandIcon /> : targetCityItem.icon = <SoilProfileDropDownIcon />;
                                    }
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }
        dispatch(updateTreeData([...treeData]));
    };

    const getRequestOptions = (isSaveQuery = false):IWeatherStationReqModel => {
        let flagForm = true;
        let formMessage = '';
        if (currentTab == TabsEnum.Name && selectedLocations.length == 0) {
            formMessage = 'Please chose one location at least.';
            flagForm = false;
        } else if (currentTab == TabsEnum.Coordinates && selectedCoordinates.length == 0) {
            formMessage = 'Please chose one coordinate at least.';
            flagForm = false;
        } else if (currentTab == TabsEnum.AdministrativeAreas && checkedCityNodes.length == 0) {
            formMessage = 'Please chose one area node at least.';
            flagForm = false;
        } else if (currentTab == TabsEnum.DrawOnMap && polygonReq === null) {
            formMessage = 'Please draw a polygon on the map.';
            flagForm = false;
        } else if (dateValue === null) {
            formMessage = 'Please pick the start date and end date!';
            flagForm = false;
        } else if (selectedSuppliersPoperties.length === 0 && currentTab !== 'Station') {
            formMessage = 'Please select one supplier properties at least!';
            flagForm = false;
        } else if (selectedSupplierStationProperties.length === 0 && currentTab === 'Station') {
            formMessage = 'Please select one supplier properties at least!';
            flagForm = false;
        }
        if (dateValue == null || dateValue == undefined) {
            formMessage = 'Please fill the start date and end date!';
            flagForm = false;
        }

        if (!flagForm) {
            showWarningMessage(formMessage);
            return;
        }

        let locations = null;
        let coordinates = null;
        let politicalAreas = null;

        switch (currentTab) {
            case TabsEnum.Name: {
                locations = selectedLocations.map(item => ({ name: `${item.adminName1},${item.adminName2}`, longitude: item.lng, latitude: item.lat }));
                break;
            }
            case TabsEnum.Coordinates: {
                coordinates = selectedCoordinates.map(x => ({ longitude: x.split(',')[0], latitude: x.split(',')[1] }));
                break;
            }
            case TabsEnum.AdministrativeAreas: {
                if (isSaveQuery) {
                    const politicalArr = checkedKeys.map((localChechKey: string) => {
                        const checkedKeyArr = localChechKey.split('&');
                        const political = {
                            region: checkedKeyArr[0],
                            country: checkedKeyArr[1],
                            state: checkedKeyArr[2],
                            cityname: checkedKeyArr[3],
                            placename: ''
                        };
                        return political;
                    });
                    politicalAreas = politicalArr;
                } else {
                    politicalAreas = checkedCityNodes;
                }
                break;
            }
        }

        let hierarchies = null;
        switch (currentTab) {
            case TabsEnum.Name:
            case TabsEnum.Coordinates:
            case TabsEnum.AdministrativeAreas:
            case TabsEnum.DrawOnMap: {
                hierarchies = selectedSuppliersPoperties.map((item) => {
                    if (item.selected) {
                        const {
                            supplier,
                            variable,
                            frequency,
                            aggregation
                        } = item;

                        return {
                            supplier,
                            variable,
                            frequency: `${frequency}_${aggregation}`,
                            hierarchy: 3
                        };
                    }

                });
                break;
            }
            case TabsEnum.Station: {
                hierarchies = selectedSupplierStationProperties.map((item) => {
                    if (item.selected) {
                        const {
                            supplier,
                            variable,
                            frequency,
                            aggregation
                        } = item;
                        return {
                            supplier,
                            variable,
                            frequency: `${frequency}_${aggregation}`,
                            hierarchy: 3
                        };
                    }
                });
                break;
            }
        }

        let tabName = 'name';
        switch (currentTab ) {
            case TabsEnum.Name: {
                tabName = 'Name';
                break;
            }
            case TabsEnum.Coordinates: {
                tabName = 'Coordinates';
                break;
            }
            case TabsEnum.AdministrativeAreas: {
                tabName = 'Administrative areas';
                break;
            }
            case TabsEnum.DrawOnMap: {
                tabName = 'Draw on map';
                break;
            }
            case TabsEnum.Station: {
                tabName = 'Station';
                break;
            }
        }
        const geometryObj = {
            drawReactModel,
            drawCircleMode,
            polyPoint,
            center,
            radius
        };
        const options: IWeatherStationReqModel = {
            tabName: tabName,
            locations: currentTab === TabsEnum.Name ? locations : null,
            coordinates: currentTab === TabsEnum.Coordinates ? coordinates : null,
            politicalAreas: currentTab === TabsEnum.AdministrativeAreas ? politicalAreas : null,
            geometryLocation: JSON.stringify(geometryObj),
            geometryText: currentTab === TabsEnum.DrawOnMap ? polygonReq : null,
            radius: currentTab === TabsEnum.Name || currentTab === TabsEnum.Coordinates ? radiusValue : null,
            startDate: moment(dateValue[0]).format('DD/MM/yyyy'),
            endDate: moment(dateValue[1]).format('DD/MM/yyyy'),
            hierarchies: hierarchies.filter(Boolean),
            hierarchiesDetails: currentTab !== TabsEnum.Station ? selectedSuppliersPoperties.filter(item => item.selected) : selectedSupplierStationProperties.filter(item => item.selected)
        };
        return options;
    };

    const executeClicked = async () => {
        if (isFetching) return;

        const options = getRequestOptions();
        if (!options) {
            return;
        }
        setMapDataIsFetching(true);

        // if options was null break the request process
        const saveQueryOptions = getRequestOptions(true);
        if (!options) {
            return;
        }
        setRequestParam(options);
        let queryId = 0;
        switch(currentTab) {
            case TabsEnum.Name: {
                queryId = nameQueryId;
                break;
            }
            case TabsEnum.Coordinates: {
                queryId = coordinateQueryId;
                break;
            }
            case TabsEnum.AdministrativeAreas: {
                queryId = admiQueryId;
                break;
            }
            case TabsEnum.DrawOnMap: {
                queryId = drawQueryId;
                break;
            }
            case TabsEnum.Station: {
                queryId = stationQueryId;
            }
        }
        const saveQueryRequestParam: IWeatherSaveQueryReqModel = {
            queryId,
            // recent query the query name must be null
            queryName: '',
            options: saveQueryOptions
        };
        const resQueryId = await weatherSaveQuery(saveQueryRequestParam);
        try {

            switch(currentTab) {
                case TabsEnum.Name: {
                    setNameQueryId(resQueryId);
                    break;
                }
                case TabsEnum.Coordinates: {
                    setCoordinateQueryId(resQueryId);
                    break;
                }
                case TabsEnum.AdministrativeAreas: {
                    setAdmiQueryId(resQueryId);
                    break;
                }
                case TabsEnum.DrawOnMap: {
                    setDrawQueryId(resQueryId);
                    break;
                }
            }
            setCurrentQueryId(resQueryId);
            const dataRes = await weatherGetWeatherStationDetail(options);
            dispatch(updateRequestOptions(options));
            const res = dataRes.data;
            switch(currentTab) {
                case TabsEnum.Name: {
                    setNameMapRes(res);
                    break;
                }
                case TabsEnum.Coordinates: {
                    setCoordinateMapRes(res);
                    break;
                }
                case TabsEnum.AdministrativeAreas: {
                    setAdminMapRes(res);
                    break;
                }
                case TabsEnum.DrawOnMap: {
                    setdrawOnMapRs(res);
                    break;
                }
                case TabsEnum.Station: {
                    setStationMapRes(res);
                    break;
                }
            }
            setMapDataIsFetching(false);
        } catch(err) {
            setNameMapRes(null);
            setMapDataIsFetching(false);
            showWarningMessage('Not found any stations according to query options!');
            // if the search result was null, set the map info was null
            switch(currentTab) {
                case TabsEnum.Name: {
                    setNameMapRes(null);
                    break;
                }
                case TabsEnum.Coordinates: {
                    setCoordinateMapRes(null);
                    break;
                }
                case TabsEnum.AdministrativeAreas: {
                    setAdminMapRes(null);
                    break;
                }
                case TabsEnum.DrawOnMap: {
                    setdrawOnMapRs(null);
                    break;
                }
            }
            dispatch(updateChartData(null));
        }
    };

    const clearButtonClicked = () => {
        setDateValue(null);
        setRadiusValue(10);
        setRequestParam(null);
        setCurrentQueryId(0);
        switch (currentTab) {
            case TabsEnum.Name: {
                setNameQueryId(0);
                setSelectedLocations([]);
                setSelectedSuppliersPoperties([]);
                setNameMapRes(null);
                break;
            }
            case TabsEnum.Coordinates: {
                setCoordinateMapRes(null);
                setSelectedSuppliersPoperties([]);
                setCoordinateQueryId(0);
                setLatLonString('');
                break;
            }
            case TabsEnum.AdministrativeAreas: {
                setAdminMapRes(null);
                setSelectedSuppliersPoperties([]);
                setAdmiQueryId(0);
                setCheckedCityNodes([]);
                setCheckedKeys([]);
                setExpandedKeys([]);
                break;
            }
            case TabsEnum.DrawOnMap: {
                setSelectedSuppliersPoperties([]);
                setdrawOnMapRs(null);
                setPolygonReq('');
                setDrawQueryId(0);
                break;
            }
            case TabsEnum.Station: {
                setSelectedSupplierStationProperties([]);
                setStationMapRes(null);
                setStationQueryId(0);
                break;
            }
        }
    };

    const removeLocationButtonClick = (index) => {
        const newSelectedLocations = [...selectedLocations];
        newSelectedLocations.splice(index, 1);
        setSelectedLocations(newSelectedLocations);
    };

    const requestForRadiusSeting = async () => {
        try {
            const res = await soilSearchGetRadiusSetting();
            dispatch(updateSearchRadiusSetting(res));
        } catch (err) {
            console.log(err);
        }
    };

    const onChange = (e) => {
        const { value } = e.target;
        const handledValue = value.replace(/[^\-?\d.],[^\-?\d.]/g, '');
        setLatLonString(handledValue);
    };

    const handleAddButtonClick = () => {
        const validate = validateLatLon(latLonString);
        if (!validate) {
            return commomWarning('Coordinate value is invalid ?');
        }
        const newCoordinates = [...selectedCoordinates];
        newCoordinates.push(latLonString);
        setSelectedCoordinates(newCoordinates);
        setLatLonString('');
    };

    const commomWarning = (message: string) => {
        return confirm({
            className: 'soil-profile-warning-div',
            okButtonProps: { style: { borderRadius: '16px', width: '80px' }},
            title: '',
            icon: (
                <div style={{height: '50px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <SoilProfileWarningAlertIcon />
                    <span style={{
                        color: '#14151C',
                        fontSize: '16px',
                        fontFamily: 'Noto-Sans-Semibold',
                        fontWeight: 600,
                        marginLeft: '17px'
                    }}>
                        Warning
                    </span>
                </div>),
            content: message,
            okText: 'OK',
            onCancel() {
                console.log('Cancel');
            },
            onOk: () => {
                console.log('click ok button');
            }
        });
    };

    const validateLatLon = (lonLat: string): boolean => {
        const lonLatArr = lonLat.split(',');
        if (lonLatArr.length !== 2) {
            return false;
        }

        if (lonLatArr.length === 2) {
            const lat = parseFloat(lonLatArr[1]);
            const lng = parseFloat(lonLatArr[0]);
            let latValidate = true;
            if (lat <= 90 && lat >= -90) {
                latValidate = true;
            } else {
                latValidate = false;
            }
            let lngValidate = true;
            if (lng <= 180 && lng >= -180) {
                lngValidate = true;
            } else {
                lngValidate = false;
            }
            return latValidate && lngValidate;
        } else {
            return false;
        }
    };

    const handleDeleteItemTag = (removeTargetItem: string, index: number) => {
        const newCoordinateSet = [...selectedCoordinates];
        newCoordinateSet.splice(index, 1);
        setSelectedCoordinates([...newCoordinateSet]);
    };

    // SECTION: render area =====================================================================================

    // Name' | 'Coordinates' | 'AdministrativeAreas' | 'DrawOnMap
    const items: {label: string, key: TabsEnum, children: React.ReactNode}[] = [
        {
            label: 'Location', key: TabsEnum.Name, children: (
                <Row>
                    <Col span={22} style={{ overflow: 'visible'}}>
                        <SoilInputSelectComponent
                            selectCallback={(select: string, option: ISoilProfilePlaceGeoNames) => {
                                const newSelectedLocations = [...selectedLocations];
                                newSelectedLocations.push(option);
                                setSelectedLocations(newSelectedLocations);
                            }}
                            selectedPlaceCount={selectedLocations?.length && 0} />
                    </Col>
                    <Col span={24} style={{marginTop: '10px'}}>
                        {
                            selectedLocations?.map((place: ISoilProfilePlaceGeoNames, index) =>
                                <span
                                    className='add-selected-place-tag'
                                    key={`${place.countryCode}-${place.geonameId}-${index}`}
                                >
                                    {`${place.name},${place.adminName1}`}
                                    <button onClick={() => removeLocationButtonClick(index)}>
                                        <SoilSearchClearIcon className='close-icon-style' />
                                    </button>
                                </span>
                            )
                        }
                    </Col>
                </Row>
            )
        },
        {
            label: 'Coordinates', key: TabsEnum.Coordinates, children: (
                <Row>
                    <Col span={22}>
                        <SoilLatLonInputSelectComponent
                            onChange={(e) => onChange(e)}
                            addButtonClick={() => handleAddButtonClick()}
                            value={latLonString}
                        />
                    </Col>
                    <Col span={24} style={{marginTop: '10px'}}>
                        {selectedCoordinates.map((item, index) => {
                            return (
                                <span
                                    className='add-selected-place-tag'
                                    key={`${item}-${index}`}
                                >
                                    {/*The page needs to display latitude and longitude, but the data passed into the background is longitude and latitude*/}
                                    {item}
                                    <button onClick={() => handleDeleteItemTag(item, index)}>
                                        <SoilSearchClearIcon className='close-icon-style' />
                                    </button>
                                </span>
                            );
                        })}
                    </Col>
                </Row>
            )
        },
        {
            label: 'Regions', key: TabsEnum.AdministrativeAreas, children: (
                <div className='soil-country-state-selected-container'>
                    <div className='admin-div'>
                        <span>Administrative areas</span>
                    </div>
                    <Spin spinning={isFetching}>
                        <Tree
                            className='state-country-tree'
                            checkable
                            treeData={treeData}
                            onSelect={onSelect}
                            onCheck={onCheck}
                            expandedKeys={expandedKeys}
                            showLine={{showLeafIcon: false}}
                            checkedKeys={checkedKeys}
                            showIcon={true}
                            checkStrictly={true}
                            blockNode={true}
                            rootStyle={{ maxHeight: '500px', overflowY: 'auto' }}
                            switcherIcon={(props: {isEnd: boolean[]}) => {
                                const isEnd = props.isEnd;
                                const end = isEnd[isEnd.length - 1];
                                return (
                                    <div style={{
                                        height: '11px',
                                        width: '23.15px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        overflow: 'visible',
                                    }}>
                                        <div
                                            style={{
                                                height: end ? '13px' : '28px',
                                                width: '1px',
                                                background: '#d9d9d9',
                                            }}
                                        />
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                height: '1px',
                                                width: '10px',
                                                background: '#d9d9d9'
                                            }}
                                        />
                                    </div>
                                );
                            }}
                        />
                    </Spin>
                </div>
            )
        },
        {
            label: 'Draw on map', key: TabsEnum.DrawOnMap, children: (
                <IF show={noticeVisible}>
                    <div className='notice-in-container'>
                        <div className = 'up-div'>
                            <button onClick={() => setNoticeVisible(false)}>
                                <SoilProfileCloseIcon />
                            </button>
                        </div>
                        <div className='down-div'>
                            <div className='left-container'>
                                <SoilSearchStar />
                            </div>
                            <div className='right-container'>
                                <span>
                                    Here you can draw polygon or circle selection. Use Rectangle or Circle buttons on the map
                                    to draw.
                                </span>
                            </div>
                        </div>
                    </div>
                </IF>
            )
        },
        {
            label: 'Station', key: TabsEnum.Station, children: null
        },
    ];

    const disableDate = (current) => {
        return current && current > moment();
    };

    function range(start, end) {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    }

    const disableTime = (date: any) => {
        const hour = moment().hour();
        const minute = moment().minute();
        const second = moment().second();
        if (date && moment(date).date() === moment().date()) {
            return {
                disabledHours: () => range(hour + 1, 24),
                disabledMinutes: (selectedHour) =>
                    selectedHour >= hour ? range(minute + 1, 60) : [],
                disabledSeconds: (selectedHour, selectedMinute) =>
                    selectedHour >= hour && selectedMinute >= minute
                        ? range(second + 1, 60)
                        : []
            };
        }
        return {
            disabledHours: () => [],
            disabledMinutes: () => [],
            disabledSeconds: () => []
        };
    };

    return (
        <div id="query-content" style={{ height: '100%' }}>
            <Modal
                open={inputQueryShow}
                className={'query-in-modal'}
                title={'Save query'}
                footer={null}
                onCancel={() => setInputQueryShow(false)}
                closeIcon={<SoilCloseIcon />}
            >
                <Spin spinning={queryIsFetching}>
                    <div>
                        <span className='save-query-span-des'>Check the Query Name before first. <br /> Location, enviroment and growing data will be save</span>
                        <div className='input-div'>
                            <span>Query name</span>
                            <Input onChange={(e) => setQueryName(e.target.value)} value={queryName} />
                        </div>
                        <div className='query-input-button-div'>
                            <button onClick={() => {
                                setQueryName('');
                                setInputQueryShow(false);
                            }}>
                             Cancel and return
                            </button>
                            <button onClick={() => saveQueryFunc()} >Save</button>
                        </div>
                    </div>
                </Spin>
            </Modal>
            <Row style={{ height: '100%'}}>
                <Col
                    span={leftMenuBarExpand ? 9 : 6}
                    style={{ paddingLeft: '24px', height: '100%', overflow: 'auto'}}
                >
                    <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                        <div style={{ display: 'flex', flex: '1', flexDirection: 'column' }}>
                            <Row>
                                <Col span={20}>
                                    <h3>Weather query</h3>
                                </Col>
                                <Col span={4}>
                                    <h3 style={{ paddingLeft: '14px' }}>
                                        <button onClick={() => setLeftMenuBarExpand(!leftMenuBarExpand)}>
                                            {leftMenuBarExpand ? <CloseSvg /> : <WeatherLeftMenuBar />}
                                        </button>
                                    </h3>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <span className='sub-title-span'>{firstTitle}</span>
                                </Col>
                            </Row>
                            <IF show={leftMenuBarExpand}>
                                <Tabs
                                    size='small'
                                    tabBarGutter={14}
                                    onChange={(tabKey: TabsEnum) => setCurrentTab(tabKey)}
                                    activeKey={currentTab}
                                    items={items}
                                />
                            </IF>
                            <IF show={!leftMenuBarExpand}>
                                <IF show={currentTab === TabsEnum.Name}>
                                    <div className='left-menu-bar-close'>
                                        {selectedLocations.map((place: ISoilProfilePlaceGeoNames) =>
                                            <span
                                                className='add-selected-place-tag'
                                                key={`${place.countryCode}-${place.geonameId}`}
                                            >
                                                {`${place.name},${place.adminName1}`}
                                            </span>
                                        )}
                                    </div>
                                </IF>
                                <IF show={currentTab === TabsEnum.Coordinates}>
                                    <div className='left-menu-bar-close'>

                                        {selectedCoordinates.map((item, index) =>
                                            <span
                                                className='add-selected-place-tag'
                                                key={`${item}-${index}`}
                                            >
                                                {/*The page needs to display latitude and longitude, but the data passed into the background is longitude and latitude*/}
                                                {(((item.replace('(', '').replace(')', '')).split(',')).reverse()).join(',')}
                                            </span>
                                        )}
                                    </div>
                                </IF>
                                <IF show={currentTab === TabsEnum.AdministrativeAreas}>
                                    <div className='left-menu-bar-close'>
                                        {checkedCityNodes.map((item, index) =>
                                            <span
                                                className='add-selected-place-tag'
                                                key={`${item}-${index}`}
                                            >
                                                {`${item.region} ${item.country} ${item.state} ${item.cityname}`}
                                                <SoilSearchClearIcon className='close-icon-style' />
                                            </span>
                                        )}
                                    </div>
                                </IF>
                            </IF>
                            <Row
                                style={{
                                    marginTop: '10px',
                                    display: (
                                        currentTab === TabsEnum.Name ||
                                        currentTab === TabsEnum.Coordinates) ? 'block' : 'none' }}>
                                <Col span={24}>
                                    <span className="sub-title-span">Radius in km</span>
                                </Col>
                                <Col span={24}>
                                    <Row className='slider-super-col'>
                                        <IF show={leftMenuBarExpand}>
                                            <Col span={19}>
                                                <Slider
                                                    className='slider-own'
                                                    min={1}
                                                    max={maxValue}
                                                    defaultValue={1}
                                                    onChange={(value)=> {
                                                        setRadiusValue(value);
                                                    }}
                                                    value={radiusValue}
                                                />
                                            </Col>
                                            <Col span={4}>
                                                <div className='radius-value-div'>
                                                    {radiusValue}
                                                </div>
                                            </Col>
                                        </IF>
                                        <IF show={!leftMenuBarExpand}>
                                            <span
                                                className='add-selected-place-tag'
                                            >
                                                {radiusValue}
                                            </span>
                                        </IF>
                                    </Row>
                                </Col>
                                <Col span={24}>
                                    <IF show={leftMenuBarExpand}>
                                        <span className="grey-span">
                                            Locations in this radius will be included
                                        </span>
                                    </IF>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: '22px' }}>
                                <Col span={24}><span className='sub-title-span'>Time range</span></Col>
                                <IF show={leftMenuBarExpand}>
                                    <Col span={24} style={{ marginTop: '8px', marginBottom: '8px' }}>
                                        <a onClick={() => { selectLastItemDate('year'); }}>Last Year</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <a onClick={() => { selectLastItemDate('month'); }}>Last Month</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <a onClick={() => { selectLastItemDate('week'); }}>Last Week</a>
                                    </Col>
                                    <Col span={24}>
                                        <RangePicker
                                            className='weather-range-picker'
                                            value={dateValue}
                                            format='DD/MM/yyyy'
                                            onChange={(value)=> setDateValue(value)}
                                            disabledDate={disableDate}
                                            disabledTime={disableTime}
                                        />
                                    </Col>
                                </IF>
                            </Row>
                            <IF show={!leftMenuBarExpand && Boolean(dateValue && dateValue.length)}>
                                <div>
                                    <span
                                        className='add-selected-place-tag'
                                    >
                                        {`${dateValue && moment(dateValue[0]).format('DD/MM/yyyy')}`}
                                    </span>
                                    <span style={{ marginRight: '6px' }}>
                                        -
                                    </span>
                                    <span
                                        className='add-selected-place-tag'
                                    >
                                        {`${dateValue && moment(dateValue[1]).format('DD/MM/yyyy')}`}
                                    </span>
                                </div>
                            </IF>
                            <Row
                                style={{
                                    marginTop: '22px',
                                }}>
                                <IF show={currentTab !== 'Station'}>
                                    <SoilSupplierPropertiesComponent
                                        show={showSupplierMenu}
                                        hideCallback={(selectedItem) => {
                                            setShowSupplierMenu(false);
                                            let isExist = false;
                                            for (const propertisItem of selectedSuppliersPoperties) {
                                                if (selectedItem.hierarchyId === propertisItem.hierarchyId) {
                                                    isExist = true;
                                                }
                                            }
                                            if (selectedItem && !isExist) {
                                                const newSelectedItem = [...selectedSuppliersPoperties, selectedItem];
                                                setSelectedSuppliersPoperties(newSelectedItem);
                                            }
                                        }}
                                    />
                                </IF>
                                <Row style={{ width: '90%' }}>
                                    <Col span={24}>
                                        <span className='sub-title-span'>
                                            {currentTab !== 'Station' ? 'Weather properties by suppliers' : 'Select weather station & property'}
                                        </span>
                                    </Col>
                                </Row>
                                <IF show={currentTab === 'Station'}>
                                    {selectedSupplierStationProperties.map((item) => {
                                        return leftMenuBarExpand ? (
                                            <Col key={item.showSelected} span={24} style={{ marginTop: '16px' }}>
                                                <SoilSupplierComponent
                                                    selectedDataSource={item}
                                                    deleteCallback={(hierarchyId) => {
                                                        const result = selectedSupplierStationProperties.filter((item) => item.hierarchyId === hierarchyId);
                                                        const target = result[0];
                                                        const index = selectedSupplierStationProperties.indexOf(target);
                                                        const cacheSelectedSupplierPropperties = [...selectedSupplierStationProperties];
                                                        cacheSelectedSupplierPropperties.splice(index, 1);
                                                        setSelectedSupplierStationProperties(cacheSelectedSupplierPropperties);
                                                        const {
                                                            station
                                                        } = result[0];
                                                        dispatch(updateDeselectedStations(station[0]));
                                                    }}
                                                    selectedCallback={(hierarchyId, selected) => {
                                                        const result = selectedSupplierStationProperties.filter((item) => item.hierarchyId === hierarchyId);
                                                        const target = result[0];
                                                        const index = selectedSupplierStationProperties.indexOf(target);
                                                        const newTarget = {...target};
                                                        newTarget.selected = selected;
                                                        const newSelectedSupplierStationProperties = [...selectedSupplierStationProperties];
                                                        newSelectedSupplierStationProperties.splice(index, 1, newTarget);
                                                        setSelectedSupplierStationProperties(newSelectedSupplierStationProperties);
                                                        dispatch(updateSelectedStations(target.station[0]));
                                                    }}
                                                    selected={item.selected}
                                                />
                                            </Col>
                                        ) : (
                                            <div className='left-menu-bar-close'>
                                                <span
                                                    className='add-selected-place-tag'
                                                >
                                                    {item.showSelected}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </IF>
                                <IF show={currentTab === 'Station'}>
                                    <SoilSupplierStationPropertiesComponent
                                        show={showSupplierMenu}
                                        hideCallback={(selectedItem) => {
                                            setShowSupplierMenu(false);
                                            let isExist = false;

                                            for (const propertisItem of selectedSupplierStationProperties) {
                                                if (selectedItem.station === propertisItem.station) {
                                                    if (selectedItem.hierarchyId === propertisItem.hierarchyId) {
                                                        isExist = true;
                                                    }
                                                }
                                            }
                                            if (selectedItem && !isExist) {
                                                const newSelectedItem = [...selectedSupplierStationProperties, selectedItem];
                                                setSelectedSupplierStationProperties(newSelectedItem);
                                                // setSelectedSuppliersPoperties(newSelectedItem);
                                            }
                                        }}
                                    />
                                </IF>
                                <Row style={{ width: '90%' }}>
                                    <IF show={currentTab !== 'Station'}>
                                        {selectedSuppliersPoperties.map((item) => {
                                            return leftMenuBarExpand ? (
                                                <Col key={item.showSelected} span={24} style={{ marginTop: '16px' }}>
                                                    <SoilSupplierComponent
                                                        selectedDataSource={item}
                                                        deleteCallback={(hierarchyId) => {
                                                            const result = selectedSuppliersPoperties.filter((item) => item.hierarchyId === hierarchyId);
                                                            const target = result[0];
                                                            const index = selectedSuppliersPoperties.indexOf(target);
                                                            const cacheSelectedSupplierPropperties = [...selectedSuppliersPoperties];
                                                            cacheSelectedSupplierPropperties.splice(index, 1);
                                                            setSelectedSuppliersPoperties(cacheSelectedSupplierPropperties);
                                                        }}
                                                        selectedCallback={(hierarchyId, selected) => {
                                                            const result = selectedSuppliersPoperties.filter((item) => item.hierarchyId === hierarchyId);
                                                            const target = result[0];
                                                            const index = selectedSuppliersPoperties.indexOf(target);
                                                            const newTarget = {...target};
                                                            newTarget.selected = selected;
                                                            selectedSuppliersPoperties.splice(index, 1, newTarget);
                                                            const newSelectedSuppliersPoperties = [...selectedSuppliersPoperties];
                                                            setSelectedSuppliersPoperties(newSelectedSuppliersPoperties);
                                                        }}
                                                        selected={item.selected}
                                                    />
                                                </Col>
                                            ) : (
                                                <div className='left-menu-bar-close'>
                                                    <span
                                                        className='add-selected-place-tag'
                                                    >
                                                        {item.showSelected}
                                                    </span>
                                                </div>
                                            );
                                        })}
                                    </IF>
                                </Row>
                                <IF show={leftMenuBarExpand}>
                                    <Row style={{ width: '90%', marginTop: '10px' }}>
                                        <Col span={24} className='add-property-div'>
                                            <button className='add-property-button' onClick={() => {
                                                if (!dateValue) {
                                                    return showWarningMessage('Should select date first!');
                                                }
                                                setShowSupplierMenu(true);
                                            }}>
                                                <span> + </span> Add weather property
                                            </button>
                                        </Col>
                                    </Row>
                                </IF>
                            </Row>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                textAlign: 'right',
                                justifyContent: 'space-between',
                                paddingRight: '25px',
                                width: '100%',
                                paddingBottom: '25px'
                            }}>
                            <Button
                                className="btn-execute"
                                onClick={() => clearButtonClicked()}
                            >
                                    Clear
                            </Button>
                            <div>
                                <Button
                                    className="btn-execute"
                                    onClick={() => setInputQueryShow(true)}
                                >
                                    Save query
                                </Button>
                                <Button
                                    className="btn-execute"
                                    onClick={() => executeClicked()}
                                >
                                    Execute
                                </Button>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col span={leftMenuBarExpand ? 15 : 18} style={{ height: '100%'}}>
                    <Spin spinning={mapDataIsFetching}>
                        <WeatherStationQueryDetails
                            queryId={currentQueryId}
                            data={
                                currentTab === TabsEnum.Name && nameMapRes ||
                                currentTab === TabsEnum.Coordinates && coordinateMapRes ||
                                currentTab === TabsEnum.AdministrativeAreas && adminMapRes ||
                                currentTab === TabsEnum.DrawOnMap && drawOnMapRes ||
                                currentTab === TabsEnum.Station && stationMapRes
                            }
                            polyPathCallback={(coordinatesReq: string) => {
                                setPolygonReq(coordinatesReq);
                            }}
                            requestParam={requestParam}
                        />
                    </Spin>
                </Col>
            </Row >
        </div>
    );
}

export {
    TabsEnum
};